import { render, staticRenderFns } from "./PhAddressBook.vue?vue&type=template&id=3b168fb3"
import script from "./PhAddressBook.vue?vue&type=script&lang=js"
export * from "./PhAddressBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports